import { Box } from '@mui/material';
import {
  RecipePresetSubstep,
  settingsInterface,
} from '../../../app/recipeCreation/createRecipe.types';
import InstructionSettingsCreation from './InstructionSettingsCreation';
import Presets from './Presets';
import { SetStateAction } from 'react';

const InstructionCreate = ({
  setSettings,
  settings,
  presetsData,
  presetSelected,
  setPresetSelected,
  isPresetOpen,
  setIsPresetOpen,
}: {
  setSettings: React.Dispatch<SetStateAction<Array<settingsInterface>>>;
  settings: Array<settingsInterface>;
  presetsData: any,
  presetSelected: RecipePresetSubstep | null;
  setPresetSelected: React.Dispatch<SetStateAction<RecipePresetSubstep | null>>;
  isPresetOpen: boolean;
  setIsPresetOpen: React.Dispatch<SetStateAction<boolean>>;
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '15px',
      alignItems: 'center',
      mt: 2,
      justifyContent: 'center',
      border: '1px solid #E8E8E8',
      borderRadius: '6px',
      padding: '10px 6px',
      height: '100%',
    }}
  >
    {isPresetOpen ?
      <Presets
        isPresetOpen={isPresetOpen}
        setIsPresetOpen={setIsPresetOpen}
        settings={settings}
        setSettings={setSettings}
        presetSelected={presetSelected}
        setPresetSelected={setPresetSelected}
        presetsData={presetsData}
      />
      :
      <InstructionSettingsCreation settings={settings} setSettings={setSettings} isPresetOpen={isPresetOpen} setIsPresetOpen={setIsPresetOpen} setPresetSelected={setPresetSelected} />
    }
  </Box>
);

export default InstructionCreate;
